import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/etity-form-provider.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { setProp } from '@shared/helpers/operators';

library.add(faPlus);

@Component({
  name: 'bpc-enroll-family-member-modal',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-std-form': StdForm,
  },
})
export default class EnrollFamilyMemberModal extends Vue {
  $refs: {
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  public config: any = {
    id: 'enroll-family-member-modal',
    title: this.$t('global.add_new_family_member') as string,
    cancelText: this.$t('global.buttons.close') as string,
    acceptText: this.$t('global.buttons.confirm') as string,
  };

  get contactRelationsPath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('contact-relations')}`;
  }

  onOpenModal() {
    console.log('onOpenModal');
    this.$bvModal.show(this.config.id);
  }
  onCloseModal() {
    this.$bvModal.hide(this.config.id);
    this.$emit('click-on-close');
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(event) {
    this.$emit('delete-media-file', event);
  }
  async saveEntity(bvModalEvent): Promise<BPCGenericApiResponse> {
    bvModalEvent.preventDefault();
    try {
      const res = await this.$refs.stdForm.saveEntity();
      this.$emit('entity-saved');
      this.$root.$emit('bv::hide::modal', this.config.id);
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  public get resolvedConfigFileName(): string {
    return this.tenantType === 'center' ? 'contact_relation' : 'contact_relation_for_club';
  }

  mounted() {
    this.$root.$on('relationCategoryChangedFromContactRelationForm', category => {
      this.setEmailValuesFromCategory(category);
    });
  }

  destroyed() {
    this.$root.$off('relationCategoryChangedFromContactRelationForm');
  }

  setEmailValuesFromCategory(category) {
    if (category && this.$refs.stdForm?.formModel) {
      setProp(this.$refs.stdForm.formModel, 'booking_emails', category?.booking_emails || false);
      setProp(
        this.$refs.stdForm.formModel,
        'accounting_emails',
        category?.accounting_emails || false,
      );
      setProp(this.$refs.stdForm.formModel, 'other_emails', category?.other_emails || false);
    }
  }
}
